module.exports = __webpack_public_path__ + "static/harvey-9dcee5e800c1460e3f9121f3265bd00f.png";